import { render, staticRenderFns } from "./Findings.vue?vue&type=template&id=64eb70bc&scoped=true"
import script from "./Findings.vue?vue&type=script&lang=js"
export * from "./Findings.vue?vue&type=script&lang=js"
import style0 from "./Findings.vue?vue&type=style&index=0&id=64eb70bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eb70bc",
  null
  
)

export default component.exports